import React from "react";
import About from "./components/about/About";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import Experience from "./components/experience/Experience";
import Project from "./components/project/Project";
import Education from "./components/education/Education";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import StarsCanvas from "./components/star/StarsCanvas";

const App = () => {
  return (
    <>
      <div className="z-0 relative">
        <Header />
        <StarsCanvas />

        <Nav />

        <About />
        <Project/>
        <Education />
        <Experience />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default App;
